import { render, staticRenderFns } from "./ManageCommittees.vue?vue&type=template&id=511598a8"
import script from "./ManageCommittees.vue?vue&type=script&lang=js"
export * from "./ManageCommittees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports